const getApiBaseUrl = (): string => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;

    if (
      hostname.includes('webcontainer.io') ||
      hostname.includes('webcontainer-api.io')
    ) {
      return `${protocol}//${hostname.replace('--5173--', '--5002--')}/api`;
    }

    const isLocalDev =
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname);

    if (isLocalDev) {
      return `${protocol}//${hostname}:5002/api`;
    }

    return `${protocol}//${hostname}/api`;
  }

  return import.meta.env.VITE_API_URL || 'http://localhost:5002/api';
};

const SESSION_KEY = 'aetherflow_visit_tracked';

export const trackPageVisit = async (path = '/'): Promise<void> => {
  if (typeof window === 'undefined') return;

  const sessionKey = `${SESSION_KEY}:${path}`;
  if (sessionStorage.getItem(sessionKey)) return;

  try {
    const response = await fetch(`${getApiBaseUrl()}/analytics/visit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path }),
    });

    if (response.ok) {
      sessionStorage.setItem(sessionKey, '1');
    }
  } catch {
    // Non-blocking — analytics should not affect UX
  }
};
